import { Pill, PillVariant } from '#/shared/components/Pill';

import { ShiftTypeLabel } from '../types/types';

const typeToVariant: Record<ShiftTypeLabel, PillVariant> = {
  Ordinary: 'surface-l0',
  'On-call': 'surface-l3',
  Callback: 'surface-l4',
};

type TimeEntryTypePillProps = {
  type: ShiftTypeLabel;
};

export function TimeEntryTypePill({ type }: Readonly<TimeEntryTypePillProps>) {
  return <Pill variant={typeToVariant[type]}>{type}</Pill>;
}
